@if (isNew()) {
  <div class="flex items-center mobi-ui-font-bold text-signature">
    <mobi-ui-icon-major
      name="rocket"
      class="block w-[24px] h-[24px] rounded-[8px] bg-bg-2 mr-[4px]"
    />
    {{ 'new' | texts: { context: 'frontend', default: 'Neu' } }}
  </div>
}
